import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon(React.createElement("path", { transform: 'translate(-3 -3)', d: 'M21 14v-4l6 5-6 5v-4h-5v5h4l-5 6-5-6h4v-5H9v4l-6-5 6-5v4h5V9h-4l5-6 5 6h-4v5h5z' }), 'DragGeofence');
const DragGeofenceIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(DragGeofenceIcon);
